import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { OrganizationContext } from '@core/organization';
import Registry, { getPlatform } from '@core/registry';
import { Debug } from '@core/debug';
import { createContext, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { PrivilegesListActions } from '../privileges/actions/PrivilegesListActions.js';
import { PrivilegesLists, privilegesListsIds } from '../privileges/constants/PrivilegesConstants.js';
import { UserPrivilegesValidator } from '../user/utils/UserPrivilegesValidator.js';
export var PrivilegesContext = /*#__PURE__*/ createContext({
    query: undefined
});
export var usePrivileges = function usePrivileges() {
    var _context_query, _context_query1;
    var context = useContext(PrivilegesContext);
    var userPrivileges = useMemo(function() {
        var _ref;
        var _context_query, _context_query1;
        return {
            privileges: context === null || context === void 0 ? void 0 : (_context_query = context.query) === null || _context_query === void 0 ? void 0 : _context_query.data,
            access: new UserPrivilegesValidator((_ref = context === null || context === void 0 ? void 0 : (_context_query1 = context.query) === null || _context_query1 === void 0 ? void 0 : _context_query1.data) !== null && _ref !== void 0 ? _ref : [])
        };
    }, [
        (_context_query = context.query) === null || _context_query === void 0 ? void 0 : _context_query.data
    ]);
    if (!context) {
        throw new Error('usePrivileges must be used within a PrivilegesProvider');
    }
    if (!((_context_query1 = context.query) === null || _context_query1 === void 0 ? void 0 : _context_query1.data)) {
        throw new Error('Privileges data is not available');
    }
    return userPrivileges;
};
export var PrivilegesProvider = function PrivilegesProvider(param) {
    var children = param.children;
    var _organizationCtx_organizationModelQuery_data, _organizationCtx_organizationModelQuery;
    var organizationCtx = useContext(OrganizationContext);
    var organizationId = (_organizationCtx_organizationModelQuery = organizationCtx.organizationModelQuery) === null || _organizationCtx_organizationModelQuery === void 0 ? void 0 : (_organizationCtx_organizationModelQuery_data = _organizationCtx_organizationModelQuery.data) === null || _organizationCtx_organizationModelQuery_data === void 0 ? void 0 : _organizationCtx_organizationModelQuery_data.id;
    var dispatch = useDispatch();
    var privilegesQuery = useQuery({
        queryKey: [
            'init',
            'user-privileges',
            organizationId
        ],
        queryFn: function queryFn() {
            return _async_to_generator(function() {
                var privileges;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getPlatform().privileges.getUserPrivileges()
                            ];
                        case 1:
                            privileges = _state.sent();
                            dispatch(PrivilegesListActions.addOrOverwrite(privilegesListsIds[PrivilegesLists.User], privileges));
                            Registry.register('userPrivileges', privileges);
                            Debug.setState('privilegesTool', function(prev) {
                                return _object_spread({}, prev, Object.fromEntries(privileges.map(function(privilege) {
                                    return [
                                        JSON.stringify(privilege),
                                        true
                                    ];
                                })));
                            });
                            return [
                                2,
                                privileges
                            ];
                    }
                });
            })();
        },
        retry: false,
        enabled: !!organizationId,
        initialData: Registry.get('userPrivileges', {
            optional: true
        }),
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsx(PrivilegesContext.Provider, {
        value: {
            query: privilegesQuery
        },
        children: children
    });
};

//# sourceMappingURL=PrivilegesContext.js.map